import React, {useContext, useState} from "react";
import {filterContextDevstat} from "../../../../_context/filterContextDevstat";
import {Grid, makeStyles, Paper, TextField, Typography} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  root: theme.filterPaper,
  inputField: {
    ...theme.inputField
  },
  marginBottom: {
    marginBottom: "10px"
  }
}));

export const PolkaFilter = () => {
  const classes = useStyles();

  const {
    state: { polkaIds }
  } = useContext(filterContextDevstat);

  const [productPolkaIds, setProductPolkaIds] = useState(polkaIds);

  return (
    <Paper className={classes.root}>
      <Typography variant="h2">Polka Ids</Typography>
      <Grid container className={classes.labels}>
        <Grid item xs={12} className={classes.marginBottom}>
          <TextField
            key="polkaIds"
            label="Polka ids"
            value={productPolkaIds || ""}
            variant="outlined"
            onChange={event => setProductPolkaIds(event.target.value)}
            name="polkaIds"
            className={classes.inputField}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
